import { EmailTemplateService } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/email-template/v1/emailtemplate.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaEmailTemplate = bindHTTP(EmailTemplateService);
